"use client";

import { useEffect, useState } from "react";
import { Modal, Button } from "@mantine/core";
import {getShopConfig} from "@/server/shop/get-shop-config";

export default function AgePopup() {
  const nshop = getShopConfig();
  const [opened, setOpened] = useState(false);
  const host = nshop?.id;
  const siteName = nshop?.publicSiteName;
  useEffect(() => {
    const isVerified = localStorage.getItem(`age_verified_${host}`);

    if (!isVerified) {
      const timer = setTimeout(() => {
        setOpened(true);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleEnter = () => {
    localStorage.setItem(`age_verified_${host}`, "true");
    setOpened(false);
  };

  const handleExit = () => {
    window.location.href = "https://google.com"; 
  };

  return (
    <Modal
      opened={opened}
      onClose={() => {}}
      centered
      withCloseButton={false}
      overlayProps={{ opacity: 0.55, blur: 3 }}
      size="lg"
      radius="md" title={`Age Verification`}
      styles={{
        header: { justifyContent: "center" },
        title: { width: "100%", textAlign: "center",fontSize: 24 },
    }}
      closeOnEscape={false}
      closeOnClickOutside={false}
    >
      <p className={'text-2xl lg:text-3xl font-bold text-center mb-3 text-green-900'}>Welcome to {siteName}</p>
      <p className={'text-center mb-3 text-base'}>This website is only for people who are <span className={'font-bold'}>18</span> or older.</p>
      <p className={'text-center text-base'}>
        Verify your age is <span className={'font-bold'}>Over 18</span>?
      </p>

      <div className={'flex flex-col lg:flex-row justify-center items-center gap-4 mt-4'}>
        <Button color="var(--color-green-800)" size="md"
                px={30} onClick={handleEnter}>
          Yes
        </Button>

        <Button  color="var(--color-red-700)" size="md"
                 px={30} onClick={handleExit}>
          No
        </Button>
      </div>

      <p className={'text-center mt-3 text-sm'}>
        By entering this site you are agreeing to the <span className={'text-blue-700'}>Terms of Use</span> and <span className={'text-blue-700'}>Privacy policy</span>
      </p>
    </Modal>
  );
}
